import { isEmpty } from 'lodash';
import { useUserSubscriptionStore } from 'store/useUserSubscriptionStore';
import { getUserSubscription } from 'store/useUserSubscriptionStore/selectors';

import { IUserSubscriptionEntity } from 'interfaces/subscriptions';

export const useCurrentSubscription = (): IUserSubscriptionEntity | null => {
  const userSubscription = useUserSubscriptionStore(getUserSubscription);

  if (!isEmpty(userSubscription)) {
    return userSubscription.currentSubscription;
  }

  return null;
};
